import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import Select from "react-select";
import { get, post } from "../../services/api";

const StudentAssessments = () => {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const userId = localStorage.getItem("userId");
  const centerId = localStorage.getItem("centerId");
  const roleId = localStorage.getItem("roleId");

  const [classesData, setClassesData] = useState([]);
  const [registrationsData, setRegistrationsData] = useState([]);
  const [assessmentData, setAssessmentData] = useState({});

  useEffect(() => {
    const fetchClassesByCenterId = async () => {
      try {
        const response = await get(
          `CenterClass/GetClassCenterByCenterId?id=${centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClassesData(response);
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    };

    fetchClassesByCenterId();
  }, []);

  const getRegistrationsList = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await get(
        `Student/GetPupilsInformationByUserId?userId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setRegistrationsData(response);
    } catch (error) {
      console.error("Error fetching Centers:", error);
    }
  };

  useEffect(() => {
    getRegistrationsList();
  }, [organizationId, centerId]);

  const fetchAssessmentDetails = async (firstRegistrationId) => {
    try {
      const response = await get(
        `AssessmentType/GetStudentAssessmentByRegId?studentFirstRegistrationId=${firstRegistrationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Store assessments in an object with registration ID as key
      setAssessmentData((prev) => ({
        ...prev,
        [firstRegistrationId]:
          response?.studentAssessmentAndInterviewDetails || [],
      }));
    } catch (error) {
      console.error("Error fetching assessment details:", error);
    }
  };

  useEffect(() => {
    registrationsData.forEach((item) => {
      fetchAssessmentDetails(item.id);
    });
  }, [registrationsData]);

  function convertTo12HourRange(timeRange) {
    const [start, end] = timeRange?.split("-");

    const formatTime = (time) => {
      const [hours, minutes] = time?.split(":");
      const date = new Date();
      date.setHours(+hours);
      date.setMinutes(+minutes);
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    };

    return `${formatTime(start)} - ${formatTime(end)}`;
  }

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Student Assessments</h2>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="row g-3">
            {registrationsData.map((item) => {
              const selectedClass = classesData.find(
                (classItem) => classItem.id === item.centerClassId
              );
              const assessmentsForStudent = assessmentData[item.id] || [];

              return (
                <div className="col-md-4" key={item.id}>
                  <div className="card h-100">
                    <div className="card-header fs-8 p-3 py-2 bg-light fw-bold">
                      {`${item.firstName} ${item.lastName}`}
                    </div>
                    <div className="fs-9 p-3">
                      <div>
                        <strong>Class:</strong> {selectedClass?.name || "N/A"}
                      </div>
                      <div>
                        <strong>Assessment Date:</strong>{" "}
                        {item.assessmentDate?.split("T")[0] || "N/A"}
                      </div>
                      <div>
                        <strong>Assessment Slot:</strong>{" "}
                        {(item.slotDate &&
                          convertTo12HourRange(item.slotDate)) ||
                          "N/A"}
                      </div>
                      <div>
                        <strong>Communication Remarks:</strong>{" "}
                        {item.communicationRemarks || "N/A"}
                      </div>
                      <div className="mt-3">
                        <strong>Assessment Result:</strong>{" "}
                        <table className="table table-bordered custom-table mt-1 mb-0">
                          <thead>
                            <tr>
                              <th>Assessment</th>
                              <th>Obtained </th>
                              <th>Total </th>
                              <th>Result</th>
                            </tr>
                          </thead>
                          <tbody>
                            {!assessmentsForStudent.length ? (
                              <tr className="text-center w-100">
                                <td colSpan="4">
                                  There are no records to display
                                </td>
                              </tr>
                            ) : (
                              assessmentsForStudent.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td>{item.assessmentTypeName}</td>
                                    <td>{item.obtainedScore}</td>
                                    <td>{item.totalScore}</td>
                                    <td>{item.resultStatus}</td>
                                  </tr>
                                );
                              })
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentAssessments;
